import { AppState } from "..";

function selectedTheme(state: AppState) {
  return state.preferences.selectedTheme;
}

export const preferencesSelectors = {
  selectedTheme,
};
